import React from 'react';
import { Flex, FlexItem, FlexProps, styled } from '@erecruit/ui-kit';
import { version } from '../../../../package.json';

import logo from './logo.svg';

const FlexContainer = styled(Flex)<FlexProps>(({ theme: { newColors } }) => ({
  width: 'fit-content',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: newColors.bgPagePrimary,
  boxSizing: 'border-box',
  borderRadius: 8,
  padding: 35,
  color: newColors.bodyPrimary,
  backgroundColor: newColors.bgPageSecondary,
}));

const createVersion = (packageJsonVersion: string): string => {
  const majorMinor = packageJsonVersion.substr(0, version.length - 1);
  return `${majorMinor}${process.env.VMS_BUILD_COUNTER || '*'}`;
};

export const About: React.FunctionComponent = () => {
  return (
    <FlexContainer direction="column" align="space-between">
      <FlexItem>
        <img src={logo} alt="Logo" />
      </FlexItem>
      <FlexItem>&nbsp;</FlexItem>
      <FlexItem>
        <b>Version {createVersion(version)}</b>
      </FlexItem>
      <FlexItem>&nbsp;</FlexItem>
      <FlexItem>Copyright © 2020 Healthtrust Inc.</FlexItem>
      <FlexItem>All rights reserved.</FlexItem>
    </FlexContainer>
  );
};
